import React from 'react'
import porfolio1 from "../../assets/images/Screenshot_4.png"
import porfolio2 from "../../assets/images/Screenshot_5.png"
import porfolio3 from "../../assets/images/Screenshot_6.png"
import porfolio4 from "../../assets/images/Screenshot_7.png"
import { CardItem } from './CardItem'

export const CardList = () => {
  const card = [
    {
      id: '1',
      title: 'Hey, I’m Alex Spencer and I love building beautiful websites',
      text: "I’m a junior front-end developer looking for a new role in an exciting company. I focus on writing accessible HTML, using modern CSS practices and writing clean JavaScript. When writing JavaScript code, I mostly use React, but I can adapt to whatever tools are required. I’m based in London, UK, but I’m happy working remotely and have experience in remote teams. When I’m not coding, you’ll find me outdoors. I love being out in nature whether that’s going for a walk, run or cycling. I’d love you to check out my work.",
      img:porfolio1,
      link: 'https://zba-imtixon-3.netlify.app/'
    },
    {
      id: '2',
      title: 'Start building with our APIs for absolutely free.',
      text: "Today, millions of people around the world have successfully connected their accounts to apps they love using our API. We provide developers with the tools they need to create easy and accessible experiences for their users.",
      img:porfolio2,
      link: 'https://payapi-project-gruppa.netlify.app/'
    },
    {
      id: '3',
      title: 'Next generation digital banking',
      text: "Take your financial life online. Your Easybank account will be a one-stop-shop for spending, saving, budgeting, investing, and much more.",
      img:porfolio3,
      link: 'https://zba-aesybank.netlify.app/'
    },
    {
      id: '4',
      title: 'We Help to Build Your Dream',
      text: "We are always availed to consult on taking your higher education to the next level so you can stay competitive in the",
      img:porfolio4,
      link: 'https://executivepage.netlify.app/'
    }
  ]
  return (
    <ul className='card-list'>
      {card.map((item, index) => {
        return <CardItem key={index} img={item.img} title={item.title} text={item.text} link={item.link} />
      })
      }
      </ul>
  )
}
